import React from 'react';
import { ValidOrderIcon } from 'assets/icons/valid-order-icon';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';

const DetailComponent = styled.div`
    span {
        font-size: 14px;
        color: ${COLOR.GREEN};
        line-height: normal;
        font-weight: 500;
        padding: 10px 0px;
        margin-left: 6px;
    }
`;

const VerifiedMark: React.FC = () => {
    return <DetailComponent>
        <p>
            <ValidOrderIcon />
            <span>Verified</span>
        </p>

    </DetailComponent>;
}

export default VerifiedMark;